<footer class="hidden-print">
  <div class ='container text-center'>
    <hr>
      <p>Da.gu.ve. CRM (Build {{appVersion}}) - &copy; {{date}} Da.gu.ve GmbH</p>
  </div>
</footer>
